import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getHealthAppointmentsHistory} from '../../services/getHealthAppointmentsHistory';

export const useGetHealthAppointmentsHistoryQuery = (refetchOnMount?: boolean | 'always') =>
	useQuery({
		queryKey: [QUERY_KEYS.HEALTH_APPOINTMENTS_HISTORY],
		queryFn: ({signal}) => getHealthAppointmentsHistory(signal),
		retry: 2,
		refetchOnMount,
	});
